export default __webpack_public_path__ + "static/media/cutRed.66566ab4.svg";